import React, { useEffect, useRef, useState } from "react";
import _ from "lodash";
import Skeleton from "@material-ui/lab/Skeleton";
import copyToClipboard from "copy-to-clipboard";
import FeedBodyHeader from "./components/FeedHeader";
import FeedCommonFooter from "../components/FeedFooter";
import FeedListContent from "../components/FeedListContent";
import { rootReducersState } from "../../../reducers";
import { useDispatch, useSelector } from "react-redux";
import {
  getFeedListRequest,
  resetFeedList,
  postLikeReset,
  updateFeedListData,
  postLikeRequest,
  feedListFlagReset,
  changeReplyData,
  resetHashTagPosts,
  getHashTagPostsRequest,
  hashtagPostFlagReset,
} from "../../../reducers/feeds/feedPost.reducer";
import { ReducerFlag } from "../../../types/reducer.types";
import appRoutes from "../../../routes/app.routes";
import { FlashMessage, NotFoundPage } from "../../../components/common";
import { CircularProgress, Grid } from "@material-ui/core/";
// import { myPost, myArticles } from "../../../services/feedPage.services";
// import Comments from "../components/Comments";


interface FeedListProps {
  isHashTagPage?: boolean;
  searchParams?: string
  myPosts?: string;
  pageSize?: number;
  fetchOnScroll?: boolean;
  feedArticle?: boolean
  readOnly?: boolean;
  feeds?: any[];
  headerUser?: {
    name?: string;
    profile_image?: string;
    isCompany?: boolean;
  };
}

const FeedList = (props: FeedListProps) => {

  const feedReducer = useSelector(
    ({ postFeed }: rootReducersState) => postFeed
  );
  const pageSize = props?.pageSize ? props?.pageSize : 20;
  const isHashTagPage = _.get(props, "isHashTagPage", false);
  const searchParams = _.get(props, "searchParams", '');
  const myPostParams = _.get(props, "myPosts", '');
  const dispatch = useDispatch();
  const postResponse = _.get(feedReducer, "postFeed", {});
  const targetData = isHashTagPage ? 'hashtagData' : "data";
  const targetPagination = isHashTagPage ? 'hashtagPostsDetail.pagination' : "detail.pagination";
  const targetDetails = isHashTagPage ? 'hashtagPostsDetail.data' : "detail.data"
  // const postData = myPost.length > 0 ? myPost : _.get(postResponse, targetData, []);
  // const [myPostsAndArticles, setMyPostsAndArticles] = useState<Array<object>>([]);
  // const [myPostPagination, setMyPagePagination] = useState({ totalPages: 0 });

  const reduxPostData = _.get(postResponse, targetData, []);
  const postData =
    props?.readOnly && Array.isArray(props?.feeds)
      ? props.feeds
      : reduxPostData;
  const pagination =  _.get(postResponse, targetPagination, {});
  const [page, setPage] = useState(1);
  const [isFetching, setIsFetching] = useState(false);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
const [nextPage, setNextPage] = useState(1);

  const likeFlag = _.get(feedReducer, "postFeed.postLikeFlag", false);
  const postFeedLikeData = _.get(feedReducer, "postFeed.likedData", {});
  const feedListFlag = _.get(feedReducer, "postFeed.feedListFlag", "");

  // Public profile mode: parent owns feed data; render from props.feeds (see postData above).
  // window.onscroll = _.debounce(() => {
  //   const docBottom =
  //     document.documentElement.getBoundingClientRect().bottom - 1200;
  //   const reachedBottom = window.innerHeight > docBottom;
  //   if (reachedBottom && !isFetching && page < pagination.totalPages) {
  //     setPage((prevPage) => prevPage + 1);
  //     setIsFetching(true);
  //   }
  // }, 100);

  // window.onscroll = _.debounce(() => {
  //   // Use a smaller offset, e.g., 200 pixels
  //   const docBottom = document.documentElement.getBoundingClientRect().bottom - 200;
  //   const reachedBottom = window.innerHeight > docBottom;
  //  if (reachedBottom && !isFetching && page < pagination.totalPages) {
  //     setPage(prevPage => prevPage + 1);
  //     setIsFetching(true);
  //   }
  // }, 100);
  
  const isFetchingRef = useRef(false);

useEffect(() => {
  isFetchingRef.current = isFetching;
}, [isFetching]);

// useEffect(() => {
//   const handleScroll = _.debounce(() => {
//     const docBottom = document.documentElement.getBoundingClientRect().bottom - 200;
//     const reachedBottom = window.innerHeight > docBottom;

//     if (
//       reachedBottom &&
//       !isFetchingRef.current &&
//       page < pagination.totalPages
//     ) {
//       setIsFetching(true);
//       setPage((prevPage) => prevPage + 1);
//     }
//   }, 100, { leading: false, trailing: true });

//   window.addEventListener("scroll", handleScroll);
//   return () => window.removeEventListener("scroll", handleScroll);
// }, [page, pagination.totalPages]);

// remove nextPage state entirely

useEffect(() => {
  if (props?.readOnly && Array.isArray(props?.feeds)) return;
  const handleScroll = _.debounce(() => {
    const { bottom } = document.documentElement.getBoundingClientRect();
    const reachedBottom = window.innerHeight > bottom - 200;

    if (
      postData.length > 0 &&
      reachedBottom &&
      !isFetchingRef.current &&
      page < pagination.totalPages && props?.fetchOnScroll !== false
    ) {
      setIsFetching(true);
      setPage((prev) => prev + 1);
    }
  }, 100);

  window.addEventListener("scroll", handleScroll);
  return () => window.removeEventListener("scroll", handleScroll);
      // eslint-disable-next-line
}, [page, pagination.totalPages, postData.length]);


useEffect(() => {
  if (nextPage > page && !isFetching && postData.length > 0) {
    setPage(nextPage);
  }
}, [nextPage, page, isFetching, postData.length]);


  useEffect(() => {
    return () => {
      dispatch(resetFeedList());
      if (!props?.readOnly) {
        dispatch(resetHashTagPosts());
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

    useEffect(() => {
    // Reset page and data when myPostParams changes
    if (myPostParams) {
      setPage(1);
      dispatch(resetFeedList());
    }
        // eslint-disable-next-line
  }, [myPostParams, dispatch]);

  // useEffect(() => {
  //   if (myPostParams.length > 0) {
  //     fetchMyPost()
  //   }
  //   // eslint-disable-next-line
  // }, [myPostParams]);

  // useEffect(() => {
  //   // call a fetch API once page is changed
  //   if (isHashTagPage) {
  //     dispatch(getHashTagPostsRequest({ searchParams, page, pageSize }));
  //   } else if (myPostParams) {
  //     fetchMyPost();
  //   }
  //   else {
  //     dispatch(getFeedListRequest({ page, pageSize }));

  //   }
  //   // eslint-disable-next-line
  // }, [page]);

useEffect(() => {
  const fetchPosts = async () => {
    if (props?.readOnly && Array.isArray(props?.feeds)) {
      setIsFetching(false);
      return;
    }
    setIsFetching(true);

    if (isHashTagPage) {
      await dispatch(getHashTagPostsRequest({ searchParams, page, pageSize }));
    } else if (myPostParams) {
      dispatch(getFeedListRequest({ page, pageSize, myPosts: myPostParams }));
    } else {
      await dispatch(getFeedListRequest({ page, pageSize }));
    }

  
  };

  fetchPosts();
  // eslint-disable-next-line
}, [page, myPostParams]);


  // useEffect(() => {
  //   const fetchPosts = async () => {
  //     if (isHashTagPage) {
  //       await dispatch(getHashTagPostsRequest({ searchParams, page, pageSize }));
  //     } else if (myPostParams) {
  //       // await fetchMyPost();
  //         dispatch(getFeedListRequest({ page, pageSize, myPosts: myPostParams }));
  //     } else {
  //       await dispatch(getFeedListRequest({ page, pageSize }));
  //     }
  //     setIsFetching(false);
  //   };
  
  //   fetchPosts();
  //     // eslint-disable-next-line
  // }, [page,myPostParams]);
  
  
  // Reset the flag once post list API is done with success of failed
useEffect(() => {
  if ([ReducerFlag.SUCCESS, ReducerFlag.FAILED].includes(feedListFlag)) {
    filterFetchData();
    setIsFetching(false);
    dispatch(feedListFlagReset());
    dispatch(hashtagPostFlagReset());
  }
      // eslint-disable-next-line
}, [feedListFlag]);

  // Hook, post like and unlike
  useEffect(() => {
    if (likeFlag === ReducerFlag.SUCCESS) {
      const updatedData = postData.map((row) => {
        if (row.id === postFeedLikeData.postId) {
          return {
            ...row,
            liked: postFeedLikeData.liked,
            post_likes_count: postFeedLikeData.totalLikes,
          };
        } else {
          return row;
        }
      });
      dispatch(updateFeedListData(updatedData));
      dispatch(postLikeReset());
    }

    // eslint-disable-next-line
  }, [likeFlag]);

  // useEffect(() => {
  //   if (likeFlag === ReducerFlag.SUCCESS) {
  //     if (myPostParams) {
  //       // Update local state for My Posts
  //       setMyPostsAndArticles((prevPosts) =>
  //         prevPosts.map((post) => {
  //           if (post.id === postFeedLikeData.postId) {
  //             return {
  //               ...post,
  //               liked: postFeedLikeData.liked,
  //               post_likes_count: postFeedLikeData.totalLikes,
  //             };
  //           }
  //           return post;
  //         })
  //       );
  //     } else {
  //       // Update Redux state for general posts list
  //       const updatedData = postData.map((row) => {
  //         if (row.id === postFeedLikeData.postId) {
  //           return {
  //             ...row,
  //             liked: postFeedLikeData.liked,
  //             post_likes_count: postFeedLikeData.totalLikes,
  //           };
  //         }
  //         return row;
  //       });
  //       dispatch(updateFeedListData(updatedData));
  //     }
  //     dispatch(postLikeReset());
  //   }
  //   // eslint-disable-next-line
  // }, [likeFlag]);
  

  const filterFetchData = () => {
    let listData = _.get(postResponse, targetDetails, []);
    let replyList = [];
    listData.forEach((post) => {
      let comments = _.get(post, "post_comments", []);
      comments.forEach((comment) => {
        let replies = _.get(comment, "reply_comments", []);
        replyList.push({
          count: replies.length,
          rows: replies,
          comment_id: _.get(comment, "id", "").toString(),
          post_id: _.get(post, "id", ""),
        });
      });
    });
    dispatch(changeReplyData(replyList));
  };

  // const fetchMyPost = async () => {
  //   setIsFetching(true)
  //   const payload = {
  //     page: page,
  //     pageSize: pageSize
  //   }
  //   let response;
  //   if (myPostParams === 'my-posts') {
  //     response = await myPost(payload);
  //   } else {
  //     response = await myArticles(payload);
  //   }
  //   const data = response.data;
  //   if (data.data.length > 0) {
  //     const myPostPagination = response.data.pagination.totalPages
  //     setMyPagePagination({ totalPages: myPostPagination })

  //     if (page > 1) {
  //       setMyPostsAndArticles((prevPosts) => [...prevPosts, ...data.data]);
  //     } else {
  //       setMyPostsAndArticles(data.data);
  //     }

  //     if (page === myPostPagination) {
  //       setIsFetching(false)
  //     }

  //   } else {
  //     setIsFetching(false)
  //   }
  // }

  if (!(postData.length > 0) && myPostParams && !(isFetching)) {
    if (myPostParams === "saved-article") {
      return (
        <NotFoundPage
          variant="articles"
          title="No Saved Articles Yet"
          description="Articles you save will appear here."
        />
      );
    }
    return (
      <NotFoundPage
        variant={myPostParams === "my-article" ? "articles" : "posts"}
      />
    );
  }
  if (props?.readOnly && _.isEmpty(postData) && !isFetching) {
    return (
      <NotFoundPage variant={props?.feedArticle ? "articles" : "posts"} />
    );
  }
  const handlePostLike = (postDetails: any) => {
    dispatch(postLikeRequest({ post_id: postDetails.id }));
  };

  const handleCopyPostLink = (postDetails: any) => {
    const postLink = appRoutes.FeedDetails.generateFullPath(postDetails.slug);
    copyToClipboard(postLink);
    FlashMessage("Copied Post link");
  };
  
  return (
    <>
      {(postData || [])?.map((data, key) => {
        const itemKey = data?.slug ?? data?.id ?? key;
        return (
          <div key={itemKey}>
            {searchParams && (
              <div className="hash-tag">#{searchParams}</div>
            )}
            <div
              className={`feed-content ${data?.post_type === 1 && !props?.feedArticle ? "feed-article-post" : ""}`}
            >

              <>
                <FeedBodyHeader
                  data={data}
                  index={key}
                  readOnly={props?.readOnly}
                  headerUser={props?.headerUser}
                />
                <FeedListContent data={data} feedArticle={props?.feedArticle} />
                <FeedCommonFooter
                  data={data}
                  postLike={(postDetails) => handlePostLike(postDetails)}
                  handleCopyPostLink={(postDetails) =>
                    handleCopyPostLink(postDetails)
                  }
                  isArticle={false}
                  defaultShowComments={true}
                  isPublicPage={!!props?.readOnly}
                />
              </>
            </div>
          </div>
        );
      })}
      {(_.isEmpty(postData) && !myPostParams && !props?.readOnly) && (
        [1, 2, 3].map((index) => {
          return (
            <div className="empty-list-wrapper" key={index}>
              <div className="loading-post">
                <Grid container>
                  <Grid item sm={1} >
                    <Skeleton variant="circle" width={50} height={50} />
                  </Grid>
                  <Grid item md={1} >
                    <Skeleton variant="text" width={300} />
                    <Skeleton variant="text" width={300} />
                  </Grid>
                </Grid>
                <Grid>
                  <Skeleton variant="text" width={1000} />
                  <Skeleton variant="text" width={1000} />
                </Grid>
              </div>
            </div>
          )
        })
      )}
      {isFetching && (
        <CircularProgress color="secondary" className="circular-progress" />
      )}
    </>
  );
};
export default FeedList;
